<template>
  <el-container class="main-page">
    <div id="wrapp" />
    <el-row style="width: 100%;height: 48px;">
      <el-row style="height: 100%;width: 100%;">
        <el-col style="width: 200px;display: flex;">
          <el-image v-if="logoUrl" :src="logoUrl" style="width: 48px; height: 36px;margin: 6px 0 0 10px;"></el-image>
          <span v-if="userInfo.systemName" class="bright-system-title-unfold" style="color: #fff;">{{userInfo.systemName}}</span>
          <span v-else class="bright-system-title-unfold" style="color: #fff;">综合能碳管理平台</span>
        </el-col>
        <el-col style="width: calc(100% - 400px);height: 100%;background-color: #fff;text-align: left;line-height: 48px;color: #999999;font-size: 14px;padding-left: 20px;">
          欢迎进入 综合能碳管理平台
        </el-col>
        <el-col style="width: 200px;height: 48px;line-height: 48px;background-color: #fff;">
          <el-menu default-active="1" mode="horizontal" class="user-horizontal-menu" background-color="rgba(0, 0, 0, 0)"
                   unique-opened text-color="rgb(10, 10, 10)">
            <el-submenu class="user-horizontal-menu-title" index="1">
              <template slot="title">
                {{userInfo.userName}}
              </template>
              <el-menu-item class="user-horizontal-menu-item" index="1-1" icon="zy-icon-tuichudenglu" @click="quit">退出登录</el-menu-item>
              <el-menu-item class="user-horizontal-menu-item" index="1-2"  icon="zy-icon-tuichudenglu" @click="changePwd">修改密码</el-menu-item>
              <el-menu-item class="user-horizontal-menu-item" index="1-3" icon="zy-icon-tuichudenglu" @click="editNotice">报警配置</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
      </el-row>
    </el-row>
    <el-row style="width: 100%;height: calc(100% - 48px);">
      <el-col id="energy-menu-scroll" style="width: 200px;height: 100%;overflow-y: auto;">
        <el-menu :key="isFold2" :default-active="defaultMenuCode2" unique-opened class="energy-vertical-menu" @open="openHandle2" @close="closeHandle2" @select="menuSelect"
                 :collapse="isFold2" background-color="rgba(0, 0, 0, 0)" text-color="#ffffffb3">
          <el-submenu v-for="(main, mainIndex) in systemData.permission" class="energy-vertical-submenu" :key="mainIndex" :index="main.id">
            <template slot="title">
              <i :class="getMenuIcon(main.id) + ' white-menu-icon'"></i>
              <span>{{main.name}}</span>
            </template>
            <el-menu-item v-for="(sub, subIndex) in main.childNode" class="energy-vertical-menu-item" :key="subIndex" :index="sub.id">
              <span style="font-size: 14px;">{{sub.name}}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
      <el-col style="width: 1px;height: 100%;background-color: #FFF;"></el-col>
      <el-col style="width: calc(100% - 201px);" class="energy-main">
        <module-selector :default-menu-code="defaultMenuCode2" :system-id="systemInfo.id" :addition-map="additionMap" :time-stamp="timeStamp" @menuClick="menuSelect"/>
      </el-col>
    </el-row>
    <el-dialog :append-to-body="true" :close-on-click-modal="false" title="修改密码" width="700px" center :visible.sync="pwdVisiable" :before-close="handleClose">
      <pwd-dialog :username="userInfo.userAccount" :key='pwdVisiable' @closeDialog="closePswDialog"/>
    </el-dialog>
    <el-dialog :append-to-body="true" :close-on-click-modal="false" title="修改语音告警配置" width="700px" center :visible.sync="noticeVisiable" :before-close="handleClose">
      <notice-dialog :userId="userInfo.userId" :key='noticeVisiable' @closeDialog="closeNoticeDialog"/>
    </el-dialog>
  </el-container>
</template>

<script>
import {Message} from "element-ui";
import {routerTo} from '../../../router';
import ModuleSelector from "./ModuleSelector";
import {toggleClass} from "../../../utils/base";
import PwdDialog from "../../EnergyEfficiency/PwdDialog";
import NoticeDialog from "../../EnergyEfficiency/NoticeDialog";
import axios from "axios"
export default {
  name: 'MainPage',
  components: {ModuleSelector, PwdDialog, NoticeDialog},
  props: {
    systemInfo: {
      type: Object,
      default() {
        return null;
      }
    },
    systemData: {
      type: Object,
      default() {
        return null;
      }
    },
    defaultMenuCode1: {
      type: String,
      default () {
        return '';
      }
    },
    defaultMenuCode2: {
      type: String,
      default () {
        return '';
      }
    }
  },
  data() {
    return {
      serverIp: '',
      isFold1: false,
      isFold2: false,
      additionMap: new Map(),
      timeStamp: 0,
      userInfo: {},
      pwdVisiable: false,
      noticeVisiable: false,
      STATIC_PERMISSION_PROP: ['id', 'name', 'parentId', 'childNode'],
      timeout: null,
      webSocket: null,
      icon: '',
      iconBrief: '',
      selMenu: ''
    }
  },
  created() {
    let baseUrl = sessionStorage.getItem('baseURL');
    this.serverIp = baseUrl.substring(baseUrl.indexOf('//') + 2, baseUrl.length);
    // this.serverIp = "ems.yukui-tech.com:443";
    sessionStorage.setItem('flashData', '0');
    this.userInfo = JSON.parse(sessionStorage.getItem('loginStore')).userInfo;
    this.defaultMenuCode1 = 0;
    this.defaultMenuCode2 = this.getMenuFirstChild();
    this.getAddition(this.systemData.permission);
    this.dealNotice();
  },
  destroyed() {
    if (this.timeout !== null) {
      clearInterval(this.timeout);
      this.timeout = null;
    }
    if(this.webSocket) {
      this.webSocket.close();
      this.webSocket = null;
    }
  },
  mounted () {
    toggleClass(document.body, 'custom-' + this.themeColor);
  },
  methods: {
    getMenuIcon(i) {
      return this.systemInfo.menuIcons[i];
    },
    noticeOpen() {
      this.menuSelect('081');
    },
    read(msg) {
      let ttsDiv = document.getElementById('wrapp')
      let au1 = '<audio id="wrapp_aud" autoplay="autoplay">'
      let sss = '<source src="http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&spd=5&per=0&text=' + msg + '" type="audio/mpeg">'
      let au2 = '</audio>'
      ttsDiv.innerHTML = au1 + sss + au2
      const wrappAudio = document.getElementById('wrapp_aud')
      wrappAudio.play()
    },
    /** 菜单关闭处理 */
    closeHandle1(val) {
      if(val === '00') {
        this.defaultMenuCode2 = val;
        this.timeStamp = new Date().getTime();
      }
    },
    /** 菜单展开处理 */
    openHandle1(val) {
      console.log(val)
      this.defaultMenuCode2 = this.getMenuFirstChild(val);
      this.timeStamp = new Date().getTime();
    },
    /** 菜单关闭处理 */
    closeHandle2(val) {
      let index = this.systemData.permission.findIndex(item => { return item.id === val });
      if (index > -1) {
        return;
      }
      if(val === '00') {
        this.defaultMenuCode2 = val;
        this.timeStamp = new Date().getTime();
      }
    },
    /** 菜单展开处理 */
    openHandle2(val) {
      let index = this.systemData.permission.findIndex(item => { return item.id === val });
      if (index > -1) {
        return;
      }
      this.defaultMenuCode2 = this.getMenuFirstChild(val);
      this.timeStamp = new Date().getTime();
    },
    /** 获取第一个子节点菜单code */
    getMenuFirstChild(val = '') {
      let childCode = '';
      if(val !== '') {
        console.log(val)
        if (this.systemData.permission[val].childNode.length > 0) {
          childCode = this.systemData.permission[val].childNode[0].id;
        }
      }else{
        for (let i = 1; i < this.systemData.permission.length; i++) {
          let childPerm = this.systemData.permission[i];
          if(childPerm.childNode && childPerm.childNode.length > 0) {
            childCode = childPerm.childNode[0].id;
            break;
          }else {
          // }else if(childPerm.id !== '00') {
            childCode = childPerm.id;
            break;
          }
        }
      }
      return childCode;
    },
    /** 获取菜单附加属性 */
    getAddition(permissions) {
      permissions.forEach((childPerm) => {
        let addition = {};
        Object.keys(childPerm).forEach((cProp) => {
          if (this.STATIC_PERMISSION_PROP.indexOf(cProp) === -1) {
            this.$set(addition, cProp, childPerm[cProp]);
          }
        });
        if (Object.keys(addition).length > 0) {
          this.additionMap.set(childPerm.id, addition);
        }
        if(childPerm.childNode && childPerm.childNode.length > 0) {
          this.getAddition(childPerm.childNode);
        }
      });
    },
    /** 菜单选中处理 */
    parentSelect(val) {
      this.defaultMenuCode1 = val;
      this.defaultMenuCode2 = this.getMenuFirstChild(val);
      console.log(this.defaultMenuCode2)
    },
    menuSelect(val) {
      this.defaultMenuCode2 = val;
      this.timeStamp = new Date().getTime();
    },
    /** 退出当前系统返回系统选择界面 */
    quit() {
      if (this.timeout !== null) {
        clearInterval(this.timeout);
      }
      if(this.webSocket) {
        this.webSocket.close();
      }
      this.themeColor = 'theme-chalk';
      sessionStorage.setItem('token', '');
      sessionStorage.setItem('loginStore', '');
      routerTo(this.$router, 'LoginPage');
    },
    changePwd() {
      if (this.userInfo.userAccount === 'admin') {
        this.$message.warning('当前账号无法修改密码');
        return;
      }
      this.pwdVisiable = true
    },
    editNotice() {
      this.noticeVisiable = true;
    },
    closePswDialog(val) {
      this.pwdVisiable = false;
      if(val === undefined) {
        this.logout();
      }
    },
    closeNoticeDialog(val) {
      this.noticeVisiable = false;
      if(val === undefined) {
        if(this.webSocket) {
          this.webSocket.close();
          this.webSocket = null;
        }
        if (this.timeout !== null) {
          clearInterval(this.timeout);
          this.timeout = null;
        }
        this.dealNotice();
      }
    },
    logout() {
      sessionStorage.setItem('store', '');
      this.$router.push({path: '/'});
    },
    dealNotice() {
      this.$api.energyMonitor.getNoticeInfo(this.userInfo.userId).then(res => {
        if (res.code !== 500) {
          let resData = res.data;
          if (resData.delFlag === 0) {
            if (resData.noticeMod === 0) {
              if (this.webSocket === null) {
                this.initSocket();
              }
            } else {
              if (this.timeout === null) {
                this.timeout = setInterval(() => {
                  this.getRecentAlarmInfo(resData.noticeNum);
                }, resData.noticeTime * 60 * 1000);
              }
            }
          }
        } else {
          Message.warning(res.message);
        }
      });
    },
    initSocket() {
      if (process.browser) {
        if ('WebSocket' in window) {
          this.webSocket = new WebSocket("wss://" + this.serverIp + "/wss/energy/websocket");
          this.initWebSocket();
          console.log('Support webSocket')
        } else {
          Message.warning('当前浏览器不支持WebSocket，无法进行语音播报！');
        }
        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
          this.useBy = 'phone'
        } else {
          this.useBy = 'pc'
        }
      }
    },
    initWebSocket() {
      this.webSocket.onopen = this.webSocketOpen;
      this.webSocket.onmessage = this.webSocketMessage;
      this.webSocket.onclose = this.webSocketClose;
      this.webSocket.onerror = this.webSocketError;
    },
    // 打开
    webSocketOpen() {
      console.log("WebSocket连接成功");
    },
    // 数据接收
    webSocketMessage(e) {
      // console.log('socket返回：', e.data);
      let params = {id: e.data};
      this.$api.energyMonitor.getAlarmById(params).then(res => {
        if (res.code === 201) {
          res.data.forEach((warnData) => {
            this.read(warnData);
          });
        } else {
          Message.warning(res.message);
        }
      })
    },
    // 关闭
    webSocketClose() {
      console.log("WebSocket关闭");
    },
    // 失败
    webSocketError() {
      console.log("WebSocket连接失败");
    },
    getRecentAlarmInfo(noticeNum) {
      this.$api.energyMonitor.getRecentAlarm(noticeNum).then(res => {
        if (res.code === 200) {
          res.data.forEach((warnData) => {
            this.read(warnData);
          });
        } else {
          Message.warning(res.message);
        }
      })
    }
  },
  computed: {
    themeColor: {
      get () { return this.$store.state.theme.themeColor; },
      set (val) {
        this.$store.commit('theme/setThemeColor', val);
      }
    },
    logoUrl() {
      if (this.userInfo.hasIcon === 1) {
        return axios.defaults.baseURL + '/sys/getUserIcon?id=' + this.userInfo.userId
      }
      return undefined
    }
  },
  watch: {
    themeColor: {
      handler () {
        toggleClass(document.body, 'custom-' + this.themeColor);
      }
    }
  }
}
</script>

<style>
  .el-menu--collapse .el-menu .el-submenu, .el-menu--popup {
    min-width: 140px!important;
    background-color: rgba(0, 0, 0, 0)!important;
  }
  .el-menu--popup {
    padding: 0!important;
  }
  .energy-vertical-submenu .el-submenu__title {
    padding-left: 30px !important;
  }
  .energy-vertical-submenu .el-submenu__title .is-opened {
    color: rgb(255, 255, 255) !important;
  }
  .energy-vertical-submenu:hover .el-submenu__title {
    color: rgb(255, 255, 255) !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .energy-vertical-menu .el-submenu__title i {
    color: rgb(242, 242, 242) !important;
  }
  #energy-menu-scroll::-webkit-scrollbar {
    display: none;
  }
</style>
<style scoped>
  .main-page{
    /*background-image: url("../../../assets/images/loginBackground.jpeg");*/
    background-color: #000000;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    font-family: Microsoft YaHei,fantasy;
  }
  .bright-system-title-unfold{
    width: calc(100% - 64px);
    height: 48px;
    line-height: 48px;
    font-weight: bold;
    font-size: 16px;
    text-align: left;
    padding: 0 12px;
  }
  .energy-vertical-menu{
    border: 0;
    overflow-y: hidden;
    text-align: center;
  }
  .energy-vertical-submenu {
    text-align: left;
  }
  .energy-vertical-menu-item{
    border: 0;
    text-align: left;
    padding-left: 60px!important;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .energy-vertical-menu-item:hover{
    color: #fff !important;
    background: rgba(255, 255, 255, 0.2) !important;
  }
  .energy-vertical-menu-item.is-active{
    background-color: #1890ff !important;
    color: rgba(255, 255, 255, 1) !important;
  }
  .horizontal-menu{
    border: 0;
    overflow-y: hidden;
    height: 48px !important;
    line-height: 48px !important;
  }
  .horizontal-menu-item{
    border: 0;
    height: 48px !important;
    line-height: 48px !important;
    text-align: center;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .horizontal-menu-item:hover{
    color: #fff !important;
    background: rgba(255, 255, 255, 0.2) !important;
  }
  .horizontal-menu-item.is-active{
    color: rgba(10, 82, 255, 1) !important;
    background: rgba(255, 255, 255, 0.8) !important;
  }
  .user-horizontal-menu{
    border: 0;
    width: 140px !important;
    height: 48px !important;
    line-height: 48px !important;
    margin-left: calc(100% - 145px);
  }
  .user-horizontal-menu-title{
    border: 0;
    width: 140px !important;
    height: 48px !important;
    line-height: 48px !important;
  }
  .user-horizontal-menu-title /deep/ .el-submenu__title{
    margin-left: calc(100% - 140px);
    border: 0 !important;;
    height: 48px !important;
    line-height: 48px !important;
  }
  .user-horizontal-menu-title.is-active /deep/ .el-submenu__title{
    color: rgb(10, 10, 10) !important;
  }
  .user-horizontal-menu-title /deep/ .el-submenu__title i{
    color: rgb(10, 10, 10) !important;
  }
  .user-horizontal-menu-title /deep/ .el-submenu__title:hover{
    background: rgba(255, 255, 255, 0.3) !important;
  }
  .user-horizontal-menu-item{
    color: #0a0a0a !important;
    border: 0;
    text-align: center;
    width: 140px !important;
    height: 48px !important;
    line-height: 48px !important;
    background-color: #FFF !important;
  }
  .user-horizontal-menu-item:hover{
    color: #0A52FF !important;
    background: rgb(215, 215, 215) !important;
  }
  .user-horizontal-menu-item.is-active{
    color: #0A52FF !important;
    background: #FFF !important;
  }
  .energy-main{
    height: 100%;
    background-color: #f0f2f5;
  }
  .black-white-button .black-white-button--text:focus, .black-white-button--text:hover {
    color: black;
    border-color: transparent;
    background-color: transparent;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 0;
  }
  .el-menu--horizontal .el-menu--popup {
    width: 140px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/main/MainPage.vue